import HelperEbro from "./HelperEbro";
import AOS from "aos";

window.addEventListener("load", function () {
  // Add AOS attributes to all <section> elements for fade-in effect
  document.querySelectorAll("section").forEach((section) => {
    section.setAttribute("data-aos", "fade-in");
  });

  // Initialize AOS
  AOS.init({
    duration: 1000,
    easing: "ease-out-sine",
  });
});

HelperEbro();
// lazySizes.cfg.loadMode = 2;
// lazySizes.cfg.preloadAfterLoad = true;

document.addEventListener(
  "click",
  function (e) {
    // loop parent nodes from the target to the delegation node
    for (var target = e.target; target && target != this; target = target.parentNode) {
      if (target.matches("#hamburger")) {
        target.classList.toggle("is-active");
        document.querySelector("nav").classList.toggle("is-active");
        document.querySelector("header").classList.toggle("is-active");
        break;
      }
    }
  },
  false
);

// Add scroll class to body when scrolled more than 10px
window.addEventListener("scroll", function () {
  if (window.scrollY > 10) {
    document.body.classList.add("scroll");
  } else {
    document.body.classList.remove("scroll");
  }
});

// Set spacer margin-top to header height on load and resize
function updateSpacerMargin() {
  const header = document.querySelector("header");
  const spacers = document.querySelectorAll(".spacer");

  if (header && spacers.length > 0) {
    const headerHeight = header.offsetHeight;
    spacers.forEach((spacer) => {
      spacer.style.height = headerHeight + "px";
    });
  }
}

window.addEventListener("load", updateSpacerMargin);

// On resize, update repeatedly for 2 seconds to account for header transition
let resizeInterval = null;
window.addEventListener("resize", function () {
  if (resizeInterval) clearInterval(resizeInterval);

  // Update immediately
  updateSpacerMargin();

  // Then update every 100ms for 2 seconds
  let elapsed = 0;
  resizeInterval = setInterval(() => {
    updateSpacerMargin();
    elapsed += 100;
    if (elapsed >= 2000) {
      clearInterval(resizeInterval);
      resizeInterval = null;
    }
  }, 100);
});

updateSpacerMargin();

/*

/**
 * GoogleMap
 * Main map rendering function that uses our GMaps API class
 * @param {string} el - Google Map selector
 * https: //github.com/stephenscaff/google-maps-es6
 */

/*
import * as Map from './Map'
if (document.querySelector('.js-map')) {
    Map.MapInit('.js-map')
}
*/
